import React from 'react';

/**
 * OfficerCapital wordmark logomark — inline SVG approximation.
 * The cap + upward-sweeping shapes from the brand mark.
 *
 * @param {number} size  pixel size, default 24
 * @param {string} capColor  fill for the cap (default warm gray)
 * @param {string} sweepColor  fill for the sweep (default capital green)
 */
export function LogoMark({ size = 24, capColor = '#7A7A7A', sweepColor = '#5BA84A' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label="OfficerCapital"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* officer cap — visor + crown */}
      <ellipse cx="50" cy="22" rx="20" ry="6" fill={capColor} />
      <path d="M 30 22 Q 30 8 50 8 Q 70 8 70 22 Z" fill={capColor} />
      <rect x="22" y="28" width="56" height="6" rx="1.5" fill={capColor} />
      {/* upward sweep — three layered shapes implying motion */}
      <path
        d="M 20 50 Q 35 42 50 48 L 48 88 Q 32 78 20 88 Z"
        fill={sweepColor}
        opacity="0.85"
      />
      <path
        d="M 36 46 Q 50 38 64 46 L 60 88 Q 48 80 36 88 Z"
        fill={sweepColor}
      />
      <path
        d="M 52 50 Q 65 44 80 50 L 76 88 Q 64 80 52 88 Z"
        fill={sweepColor}
        opacity="0.7"
      />
    </svg>
  );
}

/**
 * Wordmark — logomark + the OfficerCapital text in italic Fraunces.
 * Used in nav and footer.
 */
export function Wordmark({ size = 19, color = '#1A1A17', accent = '#5BA84A', markSize }) {
  const finalMarkSize = markSize ?? Math.round(size * 1.25);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        fontFamily: "'Fraunces', Georgia, serif",
        fontStyle: 'italic',
        fontWeight: 500,
        fontSize: size,
        color,
        letterSpacing: '-0.01em',
      }}
    >
      <LogoMark size={finalMarkSize} />
      <span>
        Officer<span style={{ color: accent }}>Capital</span>
      </span>
    </span>
  );
}
